import React from 'react';

type TextInputFieldProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  placeholder?: string;
  caption?: string;
  type?: string;
  required?: boolean;
  error?: string;
  label?: string;
  autoComplete?: string;
};


const TextInputField: React.FC<TextInputFieldProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder,
  caption,
  type = 'text',
  id,
  name,
  required = false,
  error,
  label,
  autoComplete,
}) => {
  return (
    <div className="">
      {label && <label htmlFor={id} className={`mb-2 block text-sm/6 font-medium text-gray-900 ${error ? 'text-red-500' : ''}`}>{label}</label>}
      <input
        type={type}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className={`block w-full rounded-md bg-primary-50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600 sm:text-sm/6`}
        id={id}
        name={name}
        required={required}
        autoComplete={autoComplete}
      />
      {error && error.length > 0 && < p className="text-red-500 text-sm/6">{error}</p>}
      {caption && caption.length > 0 && < p className="text-gray-400 text-sm/6">{caption}</p>}
    </div >
  );
};

export default TextInputField;